<template>
    <div class="dropdown" @mouseover="isOpen = true" @mouseleave="isOpen = false">  
        <a href="/shop/" class="button-dropdown el" v-if="!isOpen">
                {{ title }}
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path d="M310.6 246.6l-127.1 128C176.4 380.9 168.2 384 160 384s-16.38-3.125-22.63-9.375l-127.1-128C.2244 237.5-2.516 223.7 2.438 211.8S19.07 192 32 192h255.1c12.94 0 24.62 7.781 29.58 19.75S319.8 237.5 310.6 246.6z"/></svg>
        </a>
        <a href="/shop/" class="button-dropdown el" v-if="isOpen">
                {{ title }}
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path d="M9.39 265.4l127.1-128C143.6 131.1 151.8 128 160 128s16.38 3.125 22.63 9.375l127.1 128c9.156 9.156 11.9 22.91 6.943 34.88S300.9 320 287.1 320H32.01c-12.94 0-24.62-7.781-29.58-19.75S.2333 274.5 9.39 265.4z"/></svg>
        </a>
        <transition name="slide-up" appear>
            <div class="sidebar-drop prods" v-if="isOpen">
                <div class="side-cont">
                <div class="menu-col"> 
                    <img class="shopimg" src="https://skmetal.anvetogroup.com/wp-content/uploads/2024/11/%CE%B1%CF%80%CE%B1%CE%B3%CF%89%CE%B3%CE%B5%CE%B9%CF%82-%CE%BA%CE%B1%CF%80%CE%BD%CE%B1%CE%B5%CF%81%CE%B9%CF%89%CE%BD-%CF%83%CF%85%CE%B3%CE%BA%CE%BF%CE%BB%CE%BB%CE%B7%CF%83%CE%B7%CF%82-nexus-1500d-grey-3ph-380v-450x450.jpg" alt=""/>
                    <div class="menu-item2 cel">
                        <a href="/apagogeis-kapnaerion-sygkollisis-nexus-1500d-grey-3ph-380v/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" /><strong>ΑΠΑΓΩΓΕΙΣ ΚΑΠΝΑΕΡΙΩΝ ΣΥΓΚΟΛΛΗΣΗΣ NEXUS 1500D-GREY 3PH 380V</strong></a>
                    </div>                     
                </div>
                <div class="menu-col1 el">
                   <img class="shopimg" src="https://skmetal.anvetogroup.com/wp-content/uploads/2024/11/%CE%BC%CE%B7%CF%87%CE%B1%CE%BD%CE%B7-tig-all-in-one-180a-helix-power-75001800-450x450.jpg" alt=""/>
                    <div class="menu-item2 cel">
                        <a href="/michani-tig-all-in-one-180a-helix-power-75001800/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" /><strong>ΜΗΧΑΝΗ TIG ALL IN ONE 180A HELIX POWER 75001800</strong></a>
                    </div> 
                </div>

                <div class="menu-col1 en">
                    <img class="shopimg" src="https://skmetal.anvetogroup.com/wp-content/uploads/2024/11/32938-450x488.jpg" alt=""/>
                    <div class="menu-item2 cel">
                        <a href="/michani-inverter-200a-psifiaki-teltech-titanium-t200ldteltech-titanium-t200ld/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" /><strong>ΜΗΧΑΝΗ INVERTER 200A Ψηφιακή Teltech Titanium T200LDTeltech Titanium T200LD</strong></a>
                    </div> 
                </div>
                <div class="menu-col1 menu-last en">
                   <img class="shopimg" src="https://skmetal.anvetogroup.com/wp-content/uploads/2024/11/32431-450x452.jpg" alt=""/>
                    <div class="menu-item2 cel">
                        <a href="/michani-plasma-cut-cut-70l-3ph380v-nexus/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" /><strong>ΜΗΧΑΝΗ PLASMA CUT CUT-70l 3ph380V NEXUS</strong></a>
                    </div>                   
                </div>
                <div class="menu-col4 en">
                    
                </div>
            </div>
            </div>
        </transition>
        <!--<transition name="slide-up" appear>
            <div class="sidebar-drop" v-if="isOpen">
                <div class="side-cont">
                <div class="menu-col"> 
                    <div class="menu-item2 cel">
                        <a href="/celebrate-freshness/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" /><strong>CELEBRATE FRESHNESS</strong></a>
                    </div> 
                    <div class="menu-item1">
                        <a href="/collagen-chews/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" />COLLAGEN CHEWS</a>
                    </div>
                    <div class="menu-item1">
                        <a href="/happy-yak/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" />HAPPY YAK</a>
                    </div>
                    <div class="menu-item1">
                        <a href="/olive-woods/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" />OLIVE WOODS</a>
                    </div>
                    
                    <div class="menu-item1">
                        <a href="/snack-n-bark/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" />SNACK N BARK</a>
                    </div>
                    <div class="menu-item1">
                        <a href="/super-premium-snacks/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" />SUPER PREMIUM SNACKS</a>
                    </div>
                    <div class="menu-item1">
                        <a href="/the-barkers/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" />THE BARKERS</a>
                    </div>
                    <div class="menu-item1">
                        <a href="/wild-antler/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" />WILD ANTLER</a>
                    </div>
                    <div class="menu-item1">
                        <a href="/ladi-solomou/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" />ΛΑΔΙ ΣΟΛΩΜΟΥ</a>
                    </div>                 

                </div>
                <div class="menu-col1 el">
                    <div class="menu-item2 let">
                        <a href="/europremium/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" /><strong>EUROPREMIUM</strong></a>
                    </div> 
                    <div class="menu-item1">
                        <a href="/dry/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" />DRY</a>
                    </div>
                    <div class="menu-item1">
                        <a href="/snacks/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" />SNACKS</a>
                    </div>
                    <div class="menu-item2 marg">
                        <a href="/aatu/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" /><strong>AATU</strong></a>
                    </div> 
                    <div class="menu-item1">
                        <a href="/aatu-cat/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" />AATU CAT</a>
                    </div>
                    <div class="menu-item1">
                        <a href="/aatu-dog/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" />AATU DOG</a>
                    </div>
                     <div class="menu-item2 marg">
                        <a href="/shop/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" /><strong>ΠΑΙΧΝΙΔΙΑ</strong></a>
                    </div> 
                    <div class="menu-item1">
                        <a href="/nylabone/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" /><strong>NYLABONE</strong></a>
                    </div> 
                    <div class="menu-item1">
                        <a href="/pawise/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" /><strong>PAWISE</strong></a>
                    </div> 
                </div>
                <div class="menu-col1 menu-last en">
                    <div class="menu-item2 per">
                        <a href="/shop"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" /><strong>ΠΕΡΙΣΣΟΤΕΡΑ ΠΡΟΪΟΝΤΑ</strong></a>
                    </div> 
                    <div class="menu-item1">
                        <a href="/ambrosia/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" /><strong>AMBROSIA</strong></a>
                    </div> 
                     <div class="menu-item1">
                        <a href="/barking-heads-meowing-heads/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" /><strong>BARKING HEADS & MEOWING HEADS</strong></a>
                    </div>                     
                    <div class="menu-item1">
                        <a href="/savic/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" /><strong>SAVIC</strong></a>
                    </div> 
                    <div class="menu-item1">
                        <a href="/yow-up/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" /><strong>YOW UP</strong></a>
                    </div> 
                    <div class="menu-item1">
                        <a href="/dolina-piper-rafi/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" /><strong>DOLINA-PIPER-RAFI
                        </strong></a>
                    </div> 
                    <div class="menu-item1">
                        <a href="/egeo-pet-food/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" /><strong>EGEO PET FOOD
                        </strong></a>
                    </div>
                    <div class="menu-item1">
                        <a href="/inaba/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" /><strong>INABA
                        </strong></a>
                    </div>
                    <div class="menu-item1">
                        <a href="/reflex-enjoy-proline/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" /><strong>REFLEX-ENJOY-PROLINE
                        </strong></a>
                    </div>
                    <div class="menu-item1">
                        <a href="/natural-trainer/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" /><strong>NATURAL TRAINER
                        </strong></a>
                    </div>
                    <div class="menu-item1">
                        <a href="/perfect-care/"><font-awesome-icon icon="fa-solid fa-circle-arrow-right" /><strong>PERFECT CARE</strong></a>
                    </div>

                </div>
                <div class="menu-col4 en">
                    
                </div>
            </div>
            </div>
        </transition>-->
    </div>
</template>


<script>

export default ({
    name: 'sidebar-right',
    props: ['title', 'items','itemsen','titlen'],
    data () {
        return{
            isOpen: false,
            secondTime: true
        }
    }
})

</script>

<style>
.sidebar-drop .shopimg{
    background: white;
    border-radius: 20px;
    width: 180px !important;
    height: auto !important;
    padding: 20px;
    box-shadow: 0 7px 12px rgb(97 45 0 / 21%) !important;
}

.prods .menu-col{
    text-align: center !important;
}
.prods .side-cont{
    justify-content: center !important;
    height: 400px !important;
    overflow-y: hidden !important;
}
.img-text{
    display: flex;
    gap:15px !important;
    padding-left: 40px;
    margin-bottom: 25px;
}
.menu-col{
    width: 65% !important;
    padding-top: 50px !important;
    padding-left: 240px !important;
}

.menu-col1{
    width: 35% !important;
    padding-right: 240px !important;
    border-left: 1px solid #e5e5e5;
    padding-top: 50px;
    padding-bottom: 25px;
}
.prods .menu-col1{
    text-align: center !important;
    padding-right: 0px ;
    padding-left: 0px ;
}
.menu-item1{
    display: flex;
}

    .dropdown{
        text-align: center;
    }
    .button-dropdown {
        font-size: 40px;
        text-decoration: none;
        color:#222 !important;
        display: inline-block;
        position: relative;
    }
 
 .button-dropdown:after {
    content: '';
    position: absolute;
    width: 100%;
    transform: scaleX(0);
    height: 1px;
    bottom: 0;
    left: 0;
    background-color: #222;
    transform-origin: bottom right;
    transition: transform 0.25s ease-out;
}

.button-dropdown:hover:after{
  transform: scaleX(1);
  transform-origin: bottom left;
}
    .button-dropdown svg{
        margin-left: 10px;
        width:15px !important;
        filter:none !important;
    }
    .menu-item svg{
        width:10px !important;
        
    }
    .menu-btn{
        padding-left:10px !important;
    }
    .sidebar-drop img{
        width: 120px !important;
        height: 90px !important;
        object-fit: cover;
        border-radius: 5px !important;
    }
    .sidebar-drop{
        border-top: 1px solid #e7e7e7;
        background-color: #fffdfd;
        width:100% !important;
        z-index: 99;
        box-shadow: 1px 3px 3px rgb(0 0 0 / 21%);
        margin-left: auto;
        margin-right: auto;
        text-align: left;
        padding: 0px 0;
        margin-top: 20px;
        overflow: scroll;
        display: flex;
        overflow-x: hidden;
    }
 

   
    .sidebar-drop .menu-item1 {
        font-size: 20px;
        padding: 9px 40px;
        font-weight: 600;
    }

    .sidebar-drop .menu-item1 a{
       text-align: left;
       text-decoration: none;
       color:#222;
       display: inline-block;
       padding-bottom:5px;
       position: relative;
    }
    .title-text a{
        text-decoration: none;
        color:#222 !important
    }
    .title-text a:hover{
        color:#719452 !important
    }
    /* .sidebar-drop .menu-item1 a:after {
        content: '';
        position: absolute;
        width: 100%;
        transform: scaleX(0);
        height: 1px;
        bottom: 0;
        left: 0;
        background-color: #222;
        transform-origin: bottom right;
        transition: transform 0.25s ease-out;
    }*/

    .sidebar-drop .menu-item1 a:hover:after{
        transform: scaleX(1);
        transform-origin: bottom left;
    }
    .sidebar-drop.menu-item1:hover{
        background-color: #fff;
        color:#222;     
    }
    .sidebar-drop .menu-item1 a:hover{
        color:#719452 !important
    }
    .slide-up-enter-active,
    .slide-up-leave-active {
        transition: all 0.4s ease-out;
    }

.slide-up-enter,.slide-up-leave-to{
  opacity: 0;
  transform: translateY(30px);
}
/*
.slide-up-leave-to {
  opacity: 0;
  transform: translateY(-30px);
}*/

/*.prods .menu-col{
    padding-left: 0px !important;
    padding-right: 0px !important;
}*/
.prods .menu-col, .prods .menu-col1{
    width: 20% !important;
    padding-left: 25px !important;
    padding-right: 25px !important;
}
.prods .menu-last{
    margin-left: 0px !important;
    padding-left: 25px !important;
    padding-right: 25px !important;
}
@media only screen and (max-width: 767px) {
    nav .menu-item1 .sidebar{
        width:100% !important;
    }
}

</style>